import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isCrmRole } from '../lib/roles';
import { LoadFailureNotice } from './ui/LoadFailureNotice';

/**
 * The CRM pages (/sales/*) for CRM_ROLES only — the API gates every route
 * behind them the same way. A role outside the list that types the URL is
 * told it has no access, in the place the page would have been: a refusal is
 * an answer, not an empty list, and not a silent redirect that reads as a
 * broken link. (A `sales` user is in the list; SalesRouteGate above already
 * handles any /sales path not in SALES_ROUTES.)
 */
export default function CrmRouteGate() {
  const { user } = useAuth();
  if (!isCrmRole(user?.role)) {
    return (
      <div className="min-h-full bg-fieldiq-dark px-[var(--fi-page-inline)] py-[var(--fi-page-block)]">
        <LoadFailureNotice
          kind="refused"
          error={null}
          subject="the sales log"
          allowed="Admins, office staff, supervisors, dispatchers and sales"
        />
      </div>
    );
  }
  return <Outlet />;
}
